'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

EnvironmentService.$inject = ['$window'];


var _module = _angular2.default.module('cb.util.EnvironmentService', []);

_module.factory('EnvironmentService', EnvironmentService);

exports.default = _module;


function EnvironmentService($window) {
    var service = {
        getEnvironment: getEnvironment,
        isProduction: isProduction,
        isAcceptance: isAcceptance,
        isTest: isTest,
        isDevelopment: isDevelopment,
        isProxy: isProxy,
        isSitecore: isSitecore
    };

    return service;

    function getEnvironment() {
        var hostname = $window.location.hostname;
        var protocol = $window.location.protocol;

        // most common, for performance reasons on top
        if (hostname === 'www.centraalbeheer.nl' && !$window.DEVELOPMENT) {
            return 'prod';
        }
        if ($window.DEVELOPMENT) {
            return 'dev';
        }
        if (hostname.match(/acc-www\.centraalbeheer\.nl/i)) {
            return 'acc';
        }
        if (hostname.match(/wwwcentraalbeheernl\.tst\.hosting\.corp/i)) {
            return 'tst';
        }
        if (hostname.match(/^(localhost$|(127\.)|(192\.168\.)|(10\.)|(172\.1[6-9]\.)|(172\.2[0-9]\.)|(172\.3[0-1]\.)|(f[cde][0-9a-f]+:))/i) && protocol === 'https:') {
            return 'proxy';
        }
        if (hostname.match(/^(localhost$|(127\.)|(192\.168\.)|(10\.)|(172\.1[6-9]\.)|(172\.2[0-9]\.)|(172\.3[0-1]\.)|(f[cde][0-9a-f]+:))/i)) {
            return 'dev';
        }
        return 'prod';
    }

    function isProduction() {
        return getEnvironment() === 'prod';
    }

    function isAcceptance() {
        return getEnvironment() === 'acc';
    }

    function isTest() {
        return getEnvironment() === 'tst';
    }

    function isDevelopment() {
        return getEnvironment() === 'dev';
    }

    function isProxy() {
        return getEnvironment() === 'proxy';
    }

    function isSitecore() {
        var href = $window.location.href;

        return !isDevelopment() && href.indexOf('.aspx') === -1;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/util/environment.service.js
// module id = 830
// module chunks = 0